import styled from 'styled-components';

export const MovieWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
`;

export const Movie = styled.iframe`
  position: absolute;
  top: 0;
  right: 0px;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
`;

export const Description = styled.div`
  margin: 30px 0;
  white-space: pre-wrap;
`;

export const MarkdownStyle = styled.div`
  > p {
    font-size: 16px;
    margin-bottom: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Article/YoutubeSection.style.js